import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';


const Loader = (Component: React.FC) => (props: any) =>
(
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Pages
const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const HelpPage = Loader(
  lazy(() => import('src/content/pages/Help'))
);
const LoggedOut = Loader(
  lazy(() => import('src/content/pages/Status/LoggedOut'))
);

// Dashboards
const Home = Loader(
  lazy(() => import('src/content/dashboards/Home'))
);
// Applications
const Logout = Loader(
  lazy(() => import('src/components/Logout/Logout'))
);
const ResourceAssignments = Loader(
  lazy(() => import('src/content/applications/ResourceAssignments'))
);

const CRAList = Loader(
  lazy(() => import('src/content/applications/ResourceAssignments/CRAList'))
);

const DetailView = Loader(
  lazy(() => import('src/content/applications/DataObjects/Detailspage'))
);

const PaymentsInitiation = Loader(
  lazy(() => import('src/content/applications/Bankfiles/PaymentsInitiation'))
);

const PendingBankfileRequests = Loader(
  lazy(() => import('src/content/applications/Bankfiles/PendingBankfileRequests'))
);

const UserProfile = Loader(
  lazy(() => import('src/content/applications/Users/profile'))
);
const UserSignature = Loader(
  lazy(() => import('src/content/applications/Users/signature'))
);
const WorkItems = Loader(
  lazy(() => import('src/content/pages/WorkItems'))
);
const WorkItemsBankFiles = Loader(
  lazy(() => import('src/content/pages/WorkItemsBankFiles'))
);
const WorkItemsList = Loader(
  lazy(() => import('src/content/applications/WorkItems/list/WorkItemsList'))
);

const TestPage = Loader(
  lazy(() => import('src/content/pages/Test'))
);
const GraphQLPlayground = Loader(
  lazy(() => import('src/content/applications/GraphQL/GraphQLPlayground'))
);

const IdentitiesListPage = Loader(
  lazy(() => import('src/content/applications/Identities/listview/IdentitiesListPage'))
);

const SurveysListPage = Loader(
  lazy(() => import('src/content/applications/Surveys/SurveyList'))
);

const IdentitiesAdminPage = Loader(
  lazy(() => import('src/content/applications/Identities/listview/IdentitiesAdminPage'))
);

const ProcessPlayground = Loader(
  lazy(() => import('src/content/applications/Processes/ProcessPlayground'))
)

const WebServicePlayground = Loader(
  lazy(() => import('src/content/dashboards/KPI/KPIDashboard'))
)

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      {
        path: '/',
        element: <Navigate to="/dashboards/home" replace />
      },
      {
        path: 'overview',
        element: <Navigate to="/" replace />
      },
      {
        path: 'logout',
        element: <Logout />,
      },
      {
        path: 'status',
        children: [
          {
            path: '',
            element: <Navigate to="404" replace />
          },
          {
            path: '404',
            element: <Status404 />
          },
          {
            path: 'loggedout',
            element: <LoggedOut />,
          },
        ]
      },
      {
        path: '*',
        element: <Status404 />
      },
    ]
  },
  {
    path: 'details',
    element: <SidebarLayout />,
    children: [
      {
        path: ':id',
        element: <DetailView />
      },
      {
        path: '',
        element: <Navigate to="/dashboards/home" replace />
      }
    ]
  },
  {
    path: 'dashboards',
    element: <SidebarLayout />,
    children: [
      {
        path: '',
        element: <Navigate to="home" replace />
      },
      {
        path: 'home',
        element: <Home />
      },
      {
        path: 'wsplayground',
        element: <WebServicePlayground />
      }
    ]
  },
  {
    path: 'management',
    element: <SidebarLayout />,
    children: [
      {
        path: 'workitems',
        element: <WorkItems />
      },
      {
        path: 'workitemslist',
        element: <WorkItemsList />
      },
      {
        path: 'workitems/:appId',
        element: <WorkItems />
      },
      {
        path: 'assignments',
        element: <ResourceAssignments />
      },
      {
        path: 'cras',
        element: <CRAList />
      },
      {
        path: 'identities',
        element: <IdentitiesListPage />
      },
      {
        path: 'profile',
        children: [
          {
            path: '',
            element: <Navigate to="details" replace />
          },
          {
            path: 'details',
            element: <UserProfile />
          },

          {
            path: 'signature',
            element: <UserSignature />
          },
          {
            path: 'test',
            element: <TestPage />
          }
        ]
      },
      {
        path: 'help',
        element: <HelpPage />,
      },
      {
        path: 'paymentsinitiation',
        element: <PaymentsInitiation />
      },
      {
        path: 'pendingbankfilerequests',
        element: <PendingBankfileRequests />
      },
      {
        path: 'pendingbankfilerequests/:appId',
        element: <WorkItemsBankFiles />
      },
    ]
  },
  {
    path: 'setup',
    element: <SidebarLayout />,
    children: [
      {
        path: 'identities',
        element: <IdentitiesAdminPage />
      },
      {
        path: 'surveys',
        element: <SurveysListPage />
      },
      {
        path: 'processplayground',
        element: <ProcessPlayground />
      },
      {
        path: 'graphqlplayground',
        element: <GraphQLPlayground />,
      },
    ]
  }

];

export default routes;
